export const kr = {
  kr:{"users": '유저 관리/유저목록'
,"access_logs": '유저 관리/접속로그'
,"agents": '매장 관리/매장목록'
,"codes": '매장 관리/매장코드'
,"transfers": '입/출 관리'
,"cash_history": '보유금 및 포인트 내역/보유금 내역'
,"point_history":'보유금 및 포인트 내역/포인트 내역'
,"coupon_history":'보유금 및 포인트 내역/쿠폰 내역'
,"stamp_history":'보유금 및 포인트 내역/출석 내역'
,"sports":'게임 등록 및 관리/스포츠'
,"inplay":'게임 등록 및 관리/인플레이'
,"minigames":'게임 등록 및 관리/미니게임'
,"casino":'게임 등록 및 관리/카지노게임'
,"token":'게임 등록 및 관리/토큰게임'
,"bet365":'게임 등록 및 관리/bet365'
,"bet_management":'배팅 현황 관리'
,"account_management":'정산 관리'
,"helpdesk":'고객센터 및 게시판 관리/고객센터'
,"messages":'고객센터 및 게시판 관리/쪽지센터'
,"faqs":'고객센터 및 게시판 관리/FAQ'
,"freeboards":'고객센터 및 게시판 관리/자유게시판'
,"notices":'고객센터 및 게시판 관리/공지게시판'
,"events":'고객센터 및 게시판 관리/이벤트게시판'
,"game_setup":'설정/게임 기타 관리설정'
,"home_page_setup":'설정/홈페이지 설정'
,"events_promotions":'설정/이벤트 및 프로모 설정'
}
}
